<template>
        
    <app-page-content>
            <v-card>
                <v-card-title class="headline">Cambiar contraseña</v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-text-field
                                    required 
                                    label="Escriba la contraseña actual" 
                                    v-model="passwords.oldPassword" 
                                    :type="showOldPassword? 'input':'password'"
                                    :append-icon="showOldPassword ? 'visibility_off' : 'visibility'" 
                                    @click:append="showOldPassword = !showOldPassword"
                                    @input="$v.passwords.oldPassword.$touch()"
                                    :error-messages="errors.oldPassword"
                                />
                            </v-flex>
                            <v-divider inset></v-divider>
                            <v-flex xs12>
                                <v-text-field
                                    required 
                                    label="Escriba la nueva contraseña" 
                                    v-model="passwords.newPassword1" 
                                    :type="showNewPassword1? 'input':'password'"
                                    :append-icon="showNewPassword1 ? 'visibility_off' : 'visibility'" 
                                    @click:append="showNewPassword1 = !showNewPassword1"
                                    @input="$v.passwords.newPassword1.$touch()"
                                    :error-messages="errors.newPassword1"
                                />
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    required 
                                    label="Confirme la nueva contraseña" 
                                    v-model="passwords.newPassword2" 
                                    :type="showNewPassword2? 'input':'password'"
                                    :append-icon="showNewPassword2 ? 'visibility_off' : 'visibility'" 
                                    @click:append="showNewPassword2 = !showNewPassword2"
                                    @input="$v.passwords.newPassword2.$touch()"
                                    :error-messages="errors.newPassword2"
                                />
                            </v-flex>
                            <v-flex xs12>
                                <v-btn color="primary" block @click="changePassword" :disable="inProgress">Cambiar contraseña</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
            </v-card>
            <v-snackbar
                v-model="changePasswordMsg"
                :bottom="true"
                :timeout="4000"
            >
                {{msg}}
                <v-btn
                    color="pink"
                    flat
                    @click="changePasswordMsg = false"
                >
                    Cerrar
                </v-btn>
            </v-snackbar>
    </app-page-content>
</template>

<script>
import authRepository from '../../../repositories/auth.repository.js';
import { required, sameAs } from 'vuelidate/lib/validators';
export default {
    data(){
        return{
            showOldPassword: false,
            showNewPassword1: false,
            showNewPassword2: false,
            passwords: {
                oldPassword: '',
                newPassword1: '',
                newPassword2: ''
            },
            changePasswordMsg: false,
            msg: ''   
        }
    },
    validations: {
        passwords: {
            oldPassword: {required},
            newPassword1: {required},
            newPassword2: { sameAs: sameAs('newPassword1') }
        }
    },
    computed: {
        errors() {
            return {
                oldPassword: this.$v.passwords.oldPassword.$error? ['Debe escribir la contraseña actual']: [],
                newPassword1: this.$v.passwords.newPassword1.$error? ['Debe escribir la nueva contraseña']: [],
                newPassword2: this.$v.passwords.newPassword2.$error? ['La contraseña debe coincidir']: [],
            }
        }
    },
    methods: {
        changePassword(){
            this.$v.$touch();
            if(this.$v.$invalid){
                toastr.error('Debe diligenciar correctamente todos los campos obligatorios');
                return false;
            }
            this.startProcessing();

            const payload = {
                userId: this.user.id,
                password1: this.passwords.newPassword1,
                password2: this.passwords.newPassword2,
                oldPassword: this.passwords.oldPassword
            };

            const ar = {...authRepository};
                ar.changePassword(payload)
               .then(resp => {
                    this.stopProcessing();
                    const status = resp.data;
                    this.msg = status.msg;
                    if (status.status) {
                        this.cleanFields();
                        this.$v.$reset()                    
                        this.$router.push({name: 'login'});
                    } 
                    this.changePasswordMsg = true;
                 })
               .catch(error => {
                    this.stopProcessing();
                    this.msg = "Error al cambiar la contraseña";
                    this.changePasswordMsg = true;
               });
       },
       cleanFields(){
           this.oldPassword = '';
           this.newPassword1 = '';
           this.newPassword2 = '';
       }
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/MyAccount/ChangePassword/ChangePassword.vue